import ajax from '../ajax'
//获取图片列表
export function getVdtCodeApi(params) {
    return ajax({
        method: 'GET',
        url: '/new-referapi',
        params
    })
}
//获取标签数据
export function getLabelApi(params) {
    return ajax({
        method: 'GET',
        url: '/new-refertag',
        params
    })
}
//改变图片状态
export function changeImgApi(data) {
    return ajax({
        method: 'POST',
        url: '/v2/Refer/changeProcess',
        data
    })
}
//获取图片弹窗标签(弹窗)
export function getImgLabelApi(data) {
    return ajax({
        method: 'POST',
        url: '/v2/refer/taglist',
        data
    })
}
//贴标签（弹窗）
export function stickLabelApi(data) {
    return ajax({
        method: 'POST',
        url: '/v2/refer/tagModel',
        data
    })
}
// 单个标签的是否情况(标签操作)
export function singleLabelApi(data) {
    return ajax({
        method: 'POST',
        url: 'v2/refer/havetag',
        data
    })
}
// 键盘1 or 2 事件（标签操作贴标签）
export function fingerboardNumApi(data) {
    return ajax({
        method: 'POST',
        url: 'v2/refer/onetag',
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        data: data
    })
}
//删除参考图
export function deleteApi(data) {
    return ajax({
        method: 'POST',
        url: 'v2/refer/delete',
        data: data
    })
}
// 空格弹窗标签数据提交
export function spaceDataSubmitApi(data) {
    return ajax({
        method: 'POST',
        url: 'v2/refer/tagsave',
        data: data
    })
}
//排序方式
export function showApi(params) {
    return ajax({
        method: 'get',
        url: 'v2/refer/show',
        params
    })
}
//左侧菜单显示隐藏
export function showMenuApi(data) {
    return ajax({
        method: 'post',
        url: 'v2/admin/panel',
        data
    })
}



//点击左侧的checked后出现的弹窗内容
export function CheckedApi(data) {
    return ajax({
        method: 'post',
        url: 'v2/refer/dup_img',
        data
    })
}


//点击删除重复的页面
export function cloneEvtApi(data) {
    return ajax({
        method: 'post',
        url: 'v2/refer/dup_choose',
        data
    })
}






//新增

export function modeltagApi(params) {
    return ajax({
        method: 'get',
        url: 'v2/refer/author',
        params
    })
}




// WEBPACK FOOTER //
// ./src/apis/ces/a.js